/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { noop, get, toString, map } from 'lodash';

/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import Card from 'components/card';
import FormSelect from 'components/forms/form-select';

/**
 * Style dependencies
 */
import './styles.scss';

const GeneralSettings = ({ onChange = noop, locations, terminals, paytypes, groupCode, connectionType, defaultValues = {}, ...props }) => {
    const [values, setValues] = useState(defaultValues);
    const [requesting, setRequesting] = useState(true);
    const [error, setError] = useState(null);

    const handleOnChange = (e) => {
        let a = {
            ...values,
        };
        a[e.target.name] = toString(e.target.value);
        setValues(a);
        onChange({ ...a });
    };

    return (
        <>
            <Card.Section>
                <FormLabel>Register:</FormLabel>
                <Text size='xsmall'>Sales processed will be recorded from this register in Retailer.</Text>
                <FormSelect
                    onChange={handleOnChange}
                    name='salesRegister'
                    value={get(values, 'salesRegister')}
                >
                    <option value='' />
                    {map(terminals, ({ id, name }) => (
                        <option value={name} key={id}>
                            {`${name}`}
                        </option>
                    ))}
                </FormSelect>
            </Card.Section>
            <Card.Section>
                <FormLabel>Payments: </FormLabel>
                <Text size='xsmall'>Payments recorded will be recorded as this PayType in Retailer.</Text>
                <FormSelect
                    onChange={handleOnChange}
                    name='salesPayType'
                    value={toString(get(values, 'salesPayType', ''))}
                >
                    <option value='' />,
                    {map(paytypes, ({ code, name, group }) => (
                        (group == groupCode) ?
                        <option value={code} key={code}>
                            {`${name}`}
                        </option> : ''
                    ))}
                </FormSelect>
            </Card.Section>
            {/* <Card.Section>
                <FormLabel>Voucher Payments:</FormLabel>
                <Text size='xsmall'>Voucher Payments recorded will be recorded as this PayType in Retailer.</Text>
                <FormSelect
                    onChange={handleOnChange}
                    name='salesPayTypeVoucher'
                    value={toString(get(values, 'salesPayTypeVoucher', ''))}
                >
                    <option value='' />,
                    {map(paytypes, ({ code, name, group }) => (
                        (group == groupCode) ?
                        <option value={code} key={code}>
                            {`${name}`}
                        </option> : ''
                    ))}
                </FormSelect>
            </Card.Section> */}
            <Card.Section>
                <FormLabel>Voucher Payments:</FormLabel>
                <Text size='xsmall'>Voucher Payments recorded will be recorded as this PayType in Retailer.</Text>
                <FormSelect
                    onChange={handleOnChange}
                    name='salesPayTypeVoucher'
                    value={toString(get(values, 'salesPayTypeVoucher', ''))}
                >
                    <option value='' />,
                    {map(paytypes, ({ code, name, group }) => (
                        (group == groupCode) ?
                        <option value={code} key={code}>
                            {`${name}`}
                        </option> : ''
                    ))}
                </FormSelect>
            </Card.Section>
            <Card.Section>
                <FormLabel>Fulfillment:</FormLabel>
                <Text size='xsmall'>Sales processed will be fufilled from this location in Retailer.</Text>
                <FormSelect
                    onChange={handleOnChange}
                    name='salesFulfillmentLocation'
                    value={toString(get(values, 'salesFulfillmentLocation', ''))}
                >
                    <option value='' />,
                    {map(locations, ({ name, id, number }) => (
                        <option value={toString(number)} key={id}>
                            {`${name}(${number})`}
                        </option>
                    ))}
                </FormSelect>
            </Card.Section>
            <Card.Section>
                <FormLabel>Staff Initials:</FormLabel>
                <Text size='xsmall'>Please enter in the Staff members initials that you want sales to be processed under.</Text>
                <FormTextInput name='salesStaffInitials' value={toString(get(values, 'salesStaffInitials', ''))} onChange={handleOnChange} />
            </Card.Section>
        </>
    );
};

export default GeneralSettings;
